/*
 * modules/common文件夹为公共vuex状态管理器不可随意更改
 * 各业务工程需要vuex请自行建立独立文件
 * */
import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/common/app";
import user from "./modules/common/user";
import getters from "./getters";
import i18n from "./modules/common/i18n";

import addRouters from "./modules/common/generateRoutes";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    addRouters,
    i18n
  },
  getters
});

export default store;
